import React, { cloneElement } from "react";
import { FormControl } from "react-bootstrap";
import ajax from "./../lib/ajax.js";
import moment from 'moment';
import immutable from "immutable";
import context from "./../lib/context.js";
import AccrualByPlacement from "./accrual/accrual-by-placement.jsx";
import AccrualByPlacementMobile from "./accrual/accrual-by-placement-mobile.jsx";
import PtoList from "./pto/pto-list.jsx";
import AccrualViewToggler, { ACTIVITY_CALENDAR_MODE, ACTIVITY_LIST_MODE } from "./accrual/accrual-activity-view-toggler.jsx";
import PTOCalendarView from "./pto/pto-calendar-view.jsx";
import security from "../lib/security.js";
import { CLAIMS, CLAIMS_ENTITY, CLAIM_ACTIONS, FEATURES } from "../lib/claims.js";
import util from "../lib/util.js";

export default class SupervisorAccrualHome extends React.Component {
    constructor(props) {
        super(props);

        const activityMode = ACTIVITY_LIST_MODE;

        const view = util.getQueryStringValue("view").toLowerCase();

        this.state = {
            mode: "activity",
            yearSelection: "CURRENT",
            approverId: 0, // passing zero to API will compel to use current approver Id,
            subApprovers: [],
            accrualSummary: [],
            accrualSummaryLoaded: false,
            activityViewMode: view === ACTIVITY_CALENDAR_MODE ? ACTIVITY_CALENDAR_MODE : ACTIVITY_LIST_MODE,
            ptoCalendarViewAccess: false,
        }
        this.countGridLoading = 0;
        this.handleChangeYear = this.handleChangeYear.bind(this);
        this.handleChangeTab = this.handleChangeTab.bind(this);
        this.isAndroid = this.isAndroid.bind(this);
        this.isIos = this.isIos.bind(this);
        this.loadAccrualSummary = this.loadAccrualSummary.bind(this);
        this.onFilterAccrual = this.onFilterPto.bind(this);
        this.onFilterPto = this.onFilterPto.bind(this);
        this.onAccrualListLoaded = this.onAccrualListLoaded.bind(this);
        this.onPtoListLoaded = this.onPtoListLoaded.bind(this);
        this.toggleLoadingDialog = this.toggleLoadingDialog.bind(this);
    }

    componentDidMount() {
        this.toggleLoadingDialog(true); // PTO grid loading
        security.assertAccessToEntity(CLAIMS_ENTITY.Security_EntityType_Features, FEATURES.PTO_Calendar_View)
            .then(r => {
                this.setState({ ptoCalendarViewAccess: !!r.data.success });
            })
    }

    handleChangeYear(event) {
        let value = event.target.value;
        this.loadAccrualSummary(this.state.approverId, value);
    }

    handleChangeTab(mode) {
        if (mode == "summary" && !this.state.accrualSummaryLoaded)
            this.loadAccrualSummary(this.state.approverId, this.state.yearSelection);
        else
            this.setState({ mode: mode });
    }

    loadAccrualSummary(approverId, period) {
        context.message({
            show: true,
            type: "loading",
            message: "Loading. Please wait..."
        });

        let self = this;

        if (approverId == null)
            approverId = this.state.approverId;

        if (period == null)
            period = this.state.yearSelection;

        ajax.vm()
            .get(`supervisor/get-accrual-summary/${approverId}/${period}`)
            .then(res => {
                const clone = immutable.fromJS(self.state).toJS();

                // currently viewing other approver
                if (approverId > 0) {
                    const summ = clone.accrualSummary.filter(o => o.approverId == approverId);
                    if (summ.length > 0) { // forward
                        const placement = summ[0].placement;
                        clone.subApprovers.push({ approverId: approverId, approverName: placement.fullName, employeeCount: summ[0].employeeCount })
                    }
                    else { // backward
                        for (let i = clone.subApprovers.length - 1; i >= 0; i--)
                            if (clone.subApprovers[i].approverId != approverId)
                                clone.subApprovers.pop();
                    }
                }
                else {
                    clone.subApprovers = [];
                }

                clone.accrualSummary = res.data;
                clone.accrualSummaryLoaded = true;
                clone.approverId = approverId;
                clone.yearSelection = period;
                clone.mode = "summary";

                self.setState(clone, () => context.message({ show: false }));

            }).catch(function (err) {
                let data = err.response ? err.response.data : err;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    onFilterAccrual() {
        this.toggleLoadingDialog(true);
    }

    onFilterPto() {
        this.toggleLoadingDialog(true);
    }

    onAccrualListLoaded() {
        this.toggleLoadingDialog(false);
    }

    onPtoListLoaded() {
        this.toggleLoadingDialog(false);
    }

    toggleLoadingDialog(show) {
        this.countGridLoading += show ? 1 : -1;

        if (show) {
            context.message({
                show: true,
                type: "loading",
                message: "Loading. Please wait..."
            });
        }
        else if (this.countGridLoading <= 0) {
            context.message({ show: false });
            this.countGridLoading = 0;
        }
    }

    isAndroid() {
        var ua = navigator.userAgent.toLowerCase();
        return ua.indexOf("android") > -1;
    }

    isIos() {
        var ua = navigator.userAgent.toLowerCase();
        return ua.indexOf('ipad') > - 1 || ua.indexOf('iphone') > -1;
    }

    render() {
        const isMobile = this.isIos() || this.isAndroid();
        const currentMode = this.state.mode;

        return (
            <div className={isMobile ? "container ap-accrual-mobile" : "container"} style={{ padding: "10px 0px" }}>
                <div className="row">
                    <div className="col-xs-12 col-md-12 ap-accrual-title">
                        Time-Off Management
                    </div>
                </div>
                <div className={isMobile ? "row ap-px-1" : "row"}>
                    <div className="col-xs-12 col-md-12">
                        <div className="row">
                            <div className={`col-xs-3 col-md-1 ap-accrual-tab text-center ${currentMode == "activity" ? "selected" : ""}`}>
                                <span><a onClick={() => this.handleChangeTab("activity")}>Activity</a></span>
                            </div>
                            <div className={`col-xs-5 col-md-2 ap-accrual-tab text-center0 ${currentMode == "summary" ? "selected" : ""}`}>
                                <span><a onClick={() => this.handleChangeTab("summary")}>Employee Balances</a></span>
                            </div>
                            <div className="col-xs-4 col-md-9 ap-accrual-tab text-right">
                                <AccrualViewToggler isVisible={this.state.mode === "activity" && this.state.ptoCalendarViewAccess}
                                    viewMode={this.state.activityViewMode}
                                    onViewModeChange={(viewMode) => this.setState({ activityViewMode: viewMode })} />
                                <span dangerouslySetInnerHTML={{ __html: "&nbsp;" }}></span>
                            </div>
                        </div>
                    </div>
                </div>
                {this.renderActivity()}
                {this.renderSummary()}
            </div>
        );
    }

    renderSummary() {
        const self = this;
        const isMobile = this.isIos() || this.isAndroid();
        const clsRow = this.state.mode == "summary" ? "row" : "row hidden";
        const subApprovers = this.state.subApprovers;

        let breadCrumbs = null;
        if (subApprovers.length > 0) {
            breadCrumbs = <div className={clsRow} key="breadCrumbs">
                <div className="col-xs-12 col-md-12 ap-bread-crumbs">
                    <div>
                        <a href="#" onClick={() => self.loadAccrualSummary(0)}>Employee Balances</a>
                    </div>
                    <ul>
                        {subApprovers.map(o =>
                            <li key={`sub-approver_${o.approverId}`}>
                                <i className="fa fa-angle-right ap-mx-1"></i>
                                {
                                    self.state.approverId == o.approverId ? `${o.approverName} - ${o.employeeCount} Staff` :
                                        <a href="#" onClick={() => self.loadAccrualSummary(o.approverId)}>{o.approverName} - {o.employeeCount} Staff</a>
                                }
                            </li>
                        )}
                    </ul>
                </div>
            </div>
        }

        return [
            <div className={clsRow} key="filter">
                <div className="col-xs-8 col-md-4">
                    <FormControl componentClass="select" defaultValue={this.state.yearSelection} onChange={this.handleChangeYear}>
                        <option key="CURRENT" value="CURRENT">Current Year</option>
                        <option key="PRIOR" value="PRIOR">Previous Year</option>
                    </FormControl>
                </div>
            </div>,
            breadCrumbs,
            <div className={clsRow} key="grid">{
                this.state.accrualSummary.length == 0 ?
                    <div className="col-xs-12 col-md-12 ap-accrualgrid-empty">
                        No records found !
                    </div>
                    :
                    <div className="col-xs-12 col-md-12"> {
                        isMobile ?
                            <AccrualByPlacementMobile items={this.state.accrualSummary} onExpandApprover={this.loadAccrualSummary} />
                            :
                            <AccrualByPlacement items={this.state.accrualSummary} onExpandApprover={this.loadAccrualSummary} />
                    }
                    </div>
            }
            </div>
        ]
    }

    renderActivity() {
        const isMobile = this.isIos() || this.isAndroid();
        const clsRow = this.state.mode == "activity" ? (isMobile ? "row ap-px-1" : "row") : "row hidden";
        return (
            <div className={clsRow} key="grdPto">
                {
                    this.state.activityViewMode === ACTIVITY_CALENDAR_MODE ?
                        <PTOCalendarView onLoaded={this.onPtoListLoaded} /> :
                        <PtoList userRole="supervisor" title="Activity" onFilterChanged={this.onFilterPto} onLoad={this.onPtoListLoaded} />
                }
            </div>
        );
    }
}
